import React, { useState } from 'react';
import { Box, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputLabel, Slide, Typography } from "@mui/material";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { Organisations } from '../../../../../api/Endpoints/Organisation';
// import SelectX from '../../../../form/SelectX'
import TextInput from '../../../../form/TextInput'
import DateInput from '../../../../form/DateInput'
import { Departments } from '../../../../../api/Endpoints/Departments';
import { Employee } from '../../../../../api/Endpoints/Employee';
import { LoadingButton } from "@mui/lab";
import toast from "react-hot-toast";
import { ErrorMessage } from "@hookform/error-message";
import AddIcon from "@mui/icons-material/Add";
import { useEffect } from 'react';
import moment from 'moment';
import ReactSelector from 'react-select';
import { SelectX } from '../../../../form/SelectX';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const scheme = yup.object().shape({
    name: yup.string().required("field is requried"),
    phone_number: yup.string().required("field is requried"),
    // employee_roles_id: yup.object().required("field is requried"),
    // departments_id: yup.object().required("field is requried"),
    // address: yup.string().required("field is requried"),
    // emergency_contacts: yup.string(),
    // joining_date: yup.date().required("field is requried"),
    // releving_date: yup.date().required("field is requried"),
    // personal_email: yup.string().required("field is requried"),
    // work_email: yup.string().required("field is requried"),
    // remarks: yup.string(),
});


const Create = (props) => {
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, getValues, reset } = useForm({ resolver: yupResolver(scheme), criteriaMode: "all" });

    const [loading, setLoading] = useState(false)


    const [formButtonStatus, setFormButtonStatus] = useState({
        label: "Submit",
        loading: false,
        disabled: false,
    });


    const fetchDepartments = (e) => {
        return Departments.get({ keyword: e }).then(response => {
            if (typeof response.data.data.data !== "undefined") {
                return response.data.data.data;
            } else {
                return [];
            }
        })
    }

    const fetchEmployeeRoles = (e) => {
        return Employee.getRoles({ keyword: e }).then(response => {
            if (typeof response.data.data.data !== "undefined") {
                return response.data.data.data;
            } else {
                return [];
            }
        })
    }


    const Status = [
        { value: "Trainee", label: 'Trainee' },
        { value: "Intern", label: 'Intern' },
        { value: "Executive", label: 'Executive' },
        { value: "Manager", label: 'Manager' },
        { value: "Senior Executive", label: 'Senior Executive' },
        { value: "Director", label: 'Director' }


    ];
    const EmployeeTy = [
        { value: "Consultant", label: 'Consultant' },
        { value: "Employee", label: 'Employee' },
        { value: "Ex-Employee", label: 'Ex-Employee' },

    ]
    const handleFormSubmit = (data) => {
        console.log("data is here", data);
        setFormButtonStatus({ ...formButtonStatus, loading: true });
        let JoinDate = moment(data.joining_date).format('YYYY-MM-DD');
        let dataToSubmit = {
            id: props?.editId,
            users_id: watch('user_id'),
            name: data.name,
            phone_number: data.phone_number,
            departments_id: data.department_id?.id,
            email: data.personal_email,
            emergency_contacts: 3453453453453,
            parant_organisations_id: 35, //Spiderworks India
            employee_roles_id: data.employee_roles_id?.id,
            address: data.address,
            joining_date: JoinDate,
            remarks: data.remarks,
        };
        console.log("data to submit", dataToSubmit);

        let action;
        if (props.editId > 0) {
            action = Employee.update(dataToSubmit);
        } else {
            action = Employee.add(dataToSubmit);

        }

        action.then(response => {
            setFormButtonStatus({ label: "Submitted", loading: false, disabled: true });
            setFormButtonStatus({ label: "Create", loading: false, disabled: false });
            if (response.data.errors) {
                toast.error("The email or phone number has already been taken")
                return
            }
            toast.success(response.data.message)
            props.onUpdate();
            // setOpen(false)
        }).catch(errors => {
            toast.error("Internal server error");
            setFormButtonStatus({ label: "Create", loading: false, disabled: false });
            // setOpen(false)
        })
    }



    useEffect(() => {
        if (parseInt(props.editId) > 0) {
            fetchDetails()
        }
    }, [props.editId])


    const fetchDetails = async () => {

        setLoading(true)
        let EmployeeDetail = await Employee.getEmployeeDetails({ id: props.editId });
        if (EmployeeDetail.data.status === "success") {
            let data = EmployeeDetail.data.data;
            setValue('name', data.user.name);
            setValue('personal_email', data.user.email);
            setValue('phone_number', data.phone_number);
            setValue('user_id', data.users_id)
            setValue('departments_id', data.department);
            setValue('employee_roles_id', data.role);
            setValue('address', data.address);
            setValue('emergency_contacts', data.emergency_contacts);
            setValue('joining_date', data.joining_date);
            setValue('remarks', data.remarks);
        }
        setLoading(false)
        

    }



    return (
        <div>
            {/* <Button variant="contained" onClick={handleClickOpen} sx={{ mt: 2 }}>
                {props.icon ? <AddIcon style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }} /> : "Create Employee"}
            </Button> */}


            {/* <DialogTitle > {parseInt(props.editId) > 0 ? "Edit Employee" : "Create Employee"}</DialogTitle> */}

            {loading ? (
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '30vh'
                }}>
                    <CircularProgress />
                </Box >
            ) : (
                <>


                    <Grid  >
                        <Grid item xs={12} sm={12}>
                            <form onSubmit={handleSubmit(handleFormSubmit)}>
                                <Grid >
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <TextInput
                                                control={control}
                                                name="name"
                                                label="Name"
                                                value={watch('name')}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput control={control} name="phone_number"
                                                label="Phone number"
                                                value={watch('phone_number')} />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={1} mt={2}>
                                        <Grid item xs={6}>
                                            <TextInput control={control} name="personal_email"
                                                label="Personal Email"
                                                value={watch('personal_email')} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput
                                                control={control}
                                                name="work_email"
                                                label="Work Email"
                                                value={watch('work_email')}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1} mt={2}>
                                        <Grid sx={{ p: 1 }} item xs={6}>
                                            <DateInput
                                                control={control}
                                                name="releving_date"
                                                label="Relieving Date"
                                                value={watch('releving_date')}
                                            />
                                        </Grid>
                                        <Grid sx={{ p: 1 }} item xs={6}>
                                            <DateInput
                                                control={control}
                                                name="joining_date"
                                                label="Joining Date"
                                                value={watch('joining_date')}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1} mt={2}>
                                        <Grid item xs={6} sm={6}>
                                            <InputLabel sx={{
                                                color: "black",
                                            }}>Employee Level</InputLabel>
                                            <ReactSelector
                                                options={Status}
                                                value={Status.filter(requestoptions => requestoptions.label === watch('employee_level'))}
                                                name='employee_level'
                                                defaultValue={watch('employee_level')}
                                                isClearable="true"
                                                onChange={(selectedOption) => setValue('employee_level', selectedOption?.value || "")}
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999 })
                                                }}

                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <InputLabel sx={{
                                                color: "black",
                                            }}>Employee Type</InputLabel>
                                            <ReactSelector
                                                options={EmployeeTy}
                                                value={EmployeeTy.filter(requestoptions => requestoptions.label === watch('employee_type'))}
                                                name='employee_type'
                                                defaultValue={watch('employee_type')}
                                                isClearable="true"
                                                onChange={(selectedOption) => setValue('employee_type', selectedOption?.value || "")}
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999 })
                                                }}

                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1} mt={2}>
                                        <Grid item xs={6} sm={6}>
                                            <SelectX
                                                defaultOptions
                                                label={"Choose a Department"}
                                                options={fetchDepartments}
                                                control={control}
                                                error={errors.message}
                                                name={'department_id'}
                                                defaultValue={watch('department_id')}
                                            />
                                        </Grid>


                                        <Grid item xs={6} sm={6}>
                                            <SelectX
                                                defaultOptions
                                                label={"Choose a role to employee"}
                                                options={fetchEmployeeRoles}
                                                control={control}
                                                error={errors.message}
                                                name={'employee_roles_id'}
                                                defaultValue={watch('employee_roles_id')}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1} mt={2}>

                                        <Grid item xs={12} sm={6}>

                                            <TextInput control={control} name="employee_id"
                                                label="Employee ID"
                                                value={watch('employee_id')} />

                                        </Grid>
                                        <Grid item xs={12} sm={6}>

                                            <TextInput control={control} name="facebook_url"
                                                label="Facebook URL"
                                                value={watch('facebook_url')} />

                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1} mt={2}>

                                        <Grid item xs={12} sm={6}>
                                            <TextInput control={control} name="insta_url"
                                                label="Instagram URL"
                                                value={watch('insta_url')} />

                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextInput control={control} name="linkdln_url"
                                                label="Linkedln URL"
                                                value={watch('linkdln_url')} />
                                        </Grid>

                                    </Grid>
                                    <Grid item xs={12} mt={3}>
                                        <Grid item xs={12}>
                                            <TextInput control={control} name="blog_url"
                                                label="Blog URL"
                                                value={watch('blog_url')} />
                                        </Grid>
                                    </Grid>

                                    {/* <Grid item xs={12} mt={2}>
                                        <SelectX
                                            label={"Choose an organization"}
                                            options={fetchOrganisations}
                                            control={control}
                                            name={'parant_organisations_id'}
                                            defaultValue={watch('parant_organisations_id')}
                                            error={errors?.parant_organisations_id?.id ? errors?.parant_organisations_id?.id?.message : false}
                                            error2={errors?.parant_organisations_id?.message ? errors?.parant_organisations_id?.message : false}
                                        />
                                    </Grid> */}
                                    <Grid container spacing={1} mt={1}>
                                        <Grid item xs={12}>
                                            <TextInput control={control}
                                                name="address" isMultiline
                                                label="Address"
                                                row={3}
                                                value={watch('address')} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextInput
                                                control={control}
                                                name="remarks"
                                                isMultiline
                                                label="Remarks"
                                                row={3}
                                                value={watch('remarks')} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextInput
                                                control={control}
                                                name="reporting_email"
                                                isMultiline
                                                label="Reporting Email"
                                                row={3}
                                                value={watch('reporting_email')} />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} mt={2}>
                                        <ErrorMessage
                                            errors={errors}
                                            name="multipleErrorInput"
                                            render={({ messages }) =>
                                                messages &&
                                                Object.entries(messages).map(([type, message]) => (
                                                    <p key={type}>{message}</p>
                                                ))
                                            }
                                        />
                                        <LoadingButton loading={formButtonStatus.loading} disabled={formButtonStatus.disabled}
                                            variant="outlined" type="submit">{formButtonStatus.label}</LoadingButton>
                                    </Grid>
                                </Grid>
                            </form>
                        </Grid>


                    </Grid>



                </>
            )}

        </div >
    );
};

export default Create;
